import MMenu from '@mui/joy/Menu';
import MMenuItem from '@mui/joy/MenuItem';
import MMenuList from '@mui/joy/MenuList';

export const Menu: typeof MMenu = MMenu;
export const MenuItem: typeof MMenuItem = MMenuItem;
export const MenuList: typeof MMenuList = MMenuList;
